import { render, staticRenderFns } from "./KakaoPostcode.vue?vue&type=template&id=7f3b12ff&scoped=true"
import script from "./KakaoPostcode.vue?vue&type=script&lang=js"
export * from "./KakaoPostcode.vue?vue&type=script&lang=js"
import style0 from "./KakaoPostcode.vue?vue&type=style&index=0&id=7f3b12ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3b12ff",
  null
  
)

export default component.exports